import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/lpxdoe9g_Logo%20Fundo%20Transparente.png";

export default function Footer() {
  return (
      <footer
        data-testid="footer"
        className="py-12 bg-[#0A0A0A] border-t border-white/5"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Advanse IA" className="h-6 w-auto" />
              <span className="font-['Outfit'] font-semibold text-sm tracking-tight text-white">
                ADVANSE <span className="text-[#00FF00]">IA</span>
              </span>
            </div>
            <div className="flex items-center gap-8">
              <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">
                Termos de Uso
              </a>
              <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">
                Privacidade
              </a>
              <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">
                Contato
              </a>
            </div>
            <p className="font-['JetBrains_Mono'] text-xs text-white/20">
              &copy; 2025 Advanse IA. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
  );
}